import { HTMLProps, ReactNode, useState } from "react";
import { DisplayTag } from "components/tags/types";
import { Tooltip } from "@mui/material";
import { GRAY_COLOR_VALUE } from "components/tags/constants";
import { TagColorKind } from "generated/graphql";

const ACTIVE_STYLES: { [key in TagColorKind]: { bg: string; border: string } } = {
  [TagColorKind.Blue]: { bg: "bg-blue-700", border: "border-blue-700" },
  [TagColorKind.Red]: { bg: "bg-red-700", border: "border-red-700" },
  [TagColorKind.Pink]: { bg: "bg-pink-700", border: "border-pink-700" },
  [TagColorKind.Orange]: { bg: "bg-orange-800", border: "border-orange-800" },
  [TagColorKind.Brown]: { bg: "bg-yellow-900", border: "border-yellow-900" },
  [TagColorKind.Lime]: { bg: "bg-lime-800", border: "border-lime-800" },
  [TagColorKind.Green]: { bg: "bg-green-800", border: "border-green-800" },
  [TagColorKind.Purple]: { bg: "bg-purple-700", border: "border-purple-700" },
  [TagColorKind.Cyan]: { bg: "bg-cyan-700", border: "border-cyan-700" },
  [TagColorKind.Fuchsia]: { bg: "bg-fuchsia-700", border: "border-fuchsia-700" },
  [TagColorKind.Indigo]: { bg: "bg-indigo-900", border: "border-indigo-900" },
  [TagColorKind.Gray]: { bg: "bg-gray-700", border: "border-gray-700" },
};

export function TagChip({
  tag,
  startAdornment,
  endAdornment,
  active,
  tagSize,
  ...props
}: HTMLProps<HTMLDivElement> & {
  tag: DisplayTag;
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
  active?: boolean;
  tagSize?: "xs" | undefined;
}) {
  const [hovering, setHovering] = useState(false);
  const key = tag.systemName;
  const label = tag.count !== undefined ? `${tag.displayName} (${tag.count})` : tag.displayName;
  const coalescedColorValue = tag.colorValue || GRAY_COLOR_VALUE;
  const handleMouseEnter = () => setHovering(true);
  const handleMouseLeave = () => setHovering(false);
  const shouldShowHover = !props.readOnly && hovering;
  return (
    <Tooltip title={tag.description}>
      <div
        {...props}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        key={key}
        className={`flex items-center mb-1 px-1.5 py-0.5 rounded-md whitespace-nowrap text-white border ${tagSize === "xs" ? "text-xxs" : "text-xs"} ${endAdornment && "pr-1"} ${!active && "opacity-50"} ${!active && shouldShowHover && "opacity-75"} ${active && shouldShowHover && ACTIVE_STYLES[tag.color].bg} ${props.readOnly && "pointer-events-none"} ${active && ACTIVE_STYLES[tag.color].border} ${props.className}`}
        style={{
          backgroundColor: (!(active && shouldShowHover) && coalescedColorValue) || undefined,
          borderColor: (!active && coalescedColorValue) || undefined,
        }}>
        {startAdornment}
        {label}
        {endAdornment}
      </div>
    </Tooltip>
  );
}
